import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useHistory, useParams } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { deleteBoardData, getBoardDetail, saveBoardData } from "crud/search.crud";
import { useSelector } from "react-redux";
import FilePreview from "components/RopikCustom/FilePreview";

const typeItem = {
  'data' : '자료'
}

const DataRoomDetail = () => {
  const selector = useSelector(state => state)
  const { id } = useParams();
  const history = useHistory()
  
  const profileData = selector.Profile?.auth?.[0] || selector.auth?.user || {};
  const [isLoading, setIsLoading] = useState(false)
  const [detailData, setDetailData] = useState({})
  
  const getDetailData = async () => {
    if (isLoading)
      return

    setIsLoading(true)
    try {
      const params = {
        id: id
      }

      const response = await getBoardDetail(params);
      console.log(response.data)
      if (response.data.result === 'success') {
        const content = response.data.data || {}
        setDetailData(content)
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }
    
  const deleteData = async () => {
    if (isLoading)
      return

    setIsLoading(true)
    try {
      const params = {
        id: id,
        status: 'N'
      }

      const response = await deleteBoardData(params);
      if (response.data.result === 'success') {
        alert(response.data.msg)
        history.push('/notice')
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.msg)
      setIsLoading(false)
    }
  }
  
  useEffect(() => {
    getDetailData()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>공지사항 상세 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="공지사항" breadcrumbItem="공지사항 상세" />

          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">제목</td>
                          <td className="w-40">{detailData.subject}</td>
                          <td className="w-10 padding-left-8 primary-bg white-text">작성자</td>
                          <td className="w-40">{detailData.username}</td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">내용</td>
                          <td colSpan="4" className="w-40">{detailData.content}</td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">
                            첨부 사진
                          </td>
                          <td colSpan="4" className="w-90">
                            <FilePreview arr={detailData.board_file || []} handleChange={()=>{}} handleDelete={()=>{}} disabled={true}/>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div style={{ marginTop: 310 }} className="d-flex justify-content-between margin-bottom-25">
            <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 dark-bg white-text button-border" onClick={() => { history.push('/notice') }}>
              목록으로 이동
            </button>
            {profileData.id === detailData.member &&
            <div className="d-flex">
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                history.push(`/notice-update/${id}`)
              }}>
                수정하기
              </button>
              <button style={{ width: 178 }} type="button" className="custom-btn border-radius-0 error-bg white-text" onClick={() => {
                if (confirm('작성한 글을 삭제하시겠습니까?')) {
                  deleteData()
                }
              }}>
                삭제하기
              </button>
            </div>
            }
          </div>
        </Container>
      </div>

    </React.Fragment>

  )
}

export default DataRoomDetail
